'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _IconButton = require('./IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _IconButton2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/IconButton/index.js
 ** module id = 106
 ** module chunks = 0
 **/